module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<tr name=\"record-")
    ; __append(escapeFn( record.index ))
    ; __append("\" class=\"record\">\n    <td></td>\n    <td style=\"vertical-align: top\">\n        <control index=\"")
    ; __append(escapeFn( record.index ))
    ; __append("\"\n				 type=\"text\" html-name=\"key\"\n				 html-placeholder=\"Введите уникальный индекс значения\"\n				 target=\"item.records[")
    ; __append(escapeFn( record.index ))
    ; __append("].key\"/>\n    </td>\n    <td>\n        <control index=\"")
    ; __append(escapeFn( record.index ))
    ; __append("\"\n				 type=\"text-area\" html-name=\"value\"\n				 html-placeholder=\"Введите значение записи\"\n				 target=\"item.records[")
    ; __append(escapeFn( record.index ))
    ; __append("].value\"/>\n    </td>\n	<td>\n		<control index=\"")
    ; __append(escapeFn( record.index ))
    ; __append("\"\n				 type=\"xhr-autocomplete\"\n				 target=\"item.records[")
    ; __append(escapeFn( record.index ))
    ; __append("].options.dictname\"\n				 bind=\"item.records[")
    ; __append(escapeFn( record.index ))
    ; __append("].options.dictid:id\"\n				 source=\"/Dict/Web/DynDicts/page\"\n				 column=\"name\"\n				 columns=\"{name}<br><span>{description}</span>\"\n		/>\n	</td>\n</tr>\n")
  }
  return __output.join("");

}